import ErrorHandler from "./ErrorHandler"
import { api } from "services/api"
class ApiWebhook extends ErrorHandler {
  async getAll(product?: string) {
    const params: Record<string, string> = {}

    if (product) {
      params.product = product
    }

    const { data } = await api.get(`/webhook`, { params })

    return data
  }

  async getById(id?: string) {
    if (!id || id === "create") {
      // Fetch the form only
      const { data } = await api.get(`/webhook/form`)

      return data
    }
    const { data } = await api.get(`/webhook/form/${id}`)

    return data
  }

  async create(webhook: App.IWebhook) {
    return api.post("/webhook", webhook)
  }

  async update(webhook: Partial<App.IWebhook>, _id: string) {
    return api.put(`/webhook/${_id}`, webhook)
  }

  async delete(_id: string) {
    return api.delete(`/webhook/${_id}`)
  }

  async updateIsPublished(_id: string) {
    return api.patch(`/webhook/published/${_id}`)
  }
}
export default ApiWebhook
